/**
 * plural.ts — the one place a count picks its noun. The finance and HR pages
 * each carry a private copy of `plural`; this is the shared one for new
 * callers (§23.3.4's "1 days" nit is the first). Nothing here rounds: a
 * caller that displays a rounded figure rounds first and pluralises the
 * number it shows — "1.2491 days" rounds to 1 and reads "1 day"; a decimal
 * that stays decimal ("1.2 days") takes the plural like any measurement.
 */
export function plural(n: number, one: string, many: string): string {
  return n === 1 ? one : many
}

/** "N day" / "N days" for the INTEGER a card shows. */
export function dayCount(n: number): string {
  return `${n} ${plural(n, 'day', 'days')}`
}
